/* ============================================================
   Design edit 2026-08-03  (client-side)
   - Sale price -> Option B layout (通常価格 struck / 特別価格 red)
   - Inject "最短指定納期" delivery note box + お届け希望日 date selector
   Loaded only on product pages (see snippets/social-login.liquid).
   ============================================================ */
(function () {
  'use strict';

  var TAX = '<span class="pp-tax">（税込）</span>';

  // Products excluded from coupons -> show a badge next to the price.
  // Currently: Ergohuman PRO2 Low Type / ENJOY2 High Type (all frame colors).
  var COUPON_EXCLUDED_RE = /ENJOY2\s*High|PRO2\s*Low/i;
  var couponExcluded = false;
  function detectCouponExcluded() {
    var t = document.querySelector('#product h1.title, #product [itemprop="name"]');
    couponExcluded = !!(t && COUPON_EXCLUDED_RE.test(t.textContent) && !/5D/i.test(t.textContent));
  }

  function cleanMoney(text) {
    return (text || '')
      .replace(/（税込）/g, '')
      .replace(/\(税込\)/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function formatPrice(el) {
    if (!el) return;
    if (el.querySelector('.pp-sale, .pp-normal, .pp-regular')) return; // already done

    var del = el.querySelector('del, s');
    var regular = del ? cleanMoney(del.textContent) : '';

    var clone = el.cloneNode(true);
    var cdel = clone.querySelector('del, s');
    if (cdel && cdel.parentNode) cdel.parentNode.removeChild(cdel);
    var sale = cleanMoney(clone.textContent);

    if (!sale) return; // e.g. sold-out message -> leave untouched

    var badge = couponExcluded ? '<span class="pp-coupon-x">※クーポン対象外商品</span>' : '';
    var html;
    if (regular) {
      html = '<span class="pp-regular"><span class="pp-regular-label">通常価格</span> ' +
             '<s class="pp-regular-price">' + regular + TAX + '</s></span>' +
             '<span class="pp-line"><span class="pp-sale">' + sale + TAX + '</span>' + badge + '</span>';
    } else {
      html = '<span class="pp-line"><span class="pp-normal">' + sale + TAX + '</span>' + badge + '</span>';
    }
    el.innerHTML = html;
  }

  function watch(el) {
    if (!el) return;
    formatPrice(el);
    var obs = new MutationObserver(function () {
      if (!el.querySelector('.pp-sale, .pp-normal, .pp-regular')) {
        formatPrice(el);
      }
    });
    obs.observe(el, { childList: true, subtree: true });
  }

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  // Blackout ranges (inclusive), as yyyymmdd numbers. Dates in these ranges are NOT selectable.
  // e.g. お盆休業 2026/8/8 - 8/17
  var BLACKOUT = [[20260808, 20260817]];
  function isBlackout(d) {
    var key = d.getFullYear() * 10000 + (d.getMonth() + 1) * 100 + d.getDate();
    for (var r = 0; r < BLACKOUT.length; r++) {
      if (key >= BLACKOUT[r][0] && key <= BLACKOUT[r][1]) return true;
    }
    return false;
  }

  function buildDateOptions(select) {
    var wd = ['日', '月', '火', '水', '木', '金', '土'];
    var base = new Date();
    base.setHours(0, 0, 0, 0);
    base.setDate(base.getDate() + 7); // earliest = order date + 1 week
    var o0 = document.createElement('option');
    o0.value = '';
    o0.textContent = '指定なし（最短でお届け）';
    select.appendChild(o0);
    var added = 0, i = 0;
    while (added < 35 && i < 400) {
      var d = new Date(base.getTime());
      d.setDate(d.getDate() + i);
      i++;
      if (isBlackout(d)) continue; // skip blackout dates
      var opt = document.createElement('option');
      var mdLabel = (d.getMonth() + 1) + '月' + d.getDate() + '日（' + wd[d.getDay()] + '）';
      // record the full date (with year) on the order; show a compact label in the dropdown
      opt.value = d.getFullYear() + '年' + mdLabel;
      opt.textContent = mdLabel;
      select.appendChild(opt);
      added++;
    }
  }

  function injectDelivery() {
    var form = document.getElementById('add-item-form');
    if (!form || form.querySelector('.meliora-delivery-note')) return;

    var box = document.createElement('div');
    box.className = 'meliora-delivery-note';

    var row = document.createElement('div');
    row.className = 'mdn-row';
    row.innerHTML = '<span class="mdn-label">発送目安</span>' +
                    '<span class="mdn-value">ご注文から3営業日以内に発送いたします</span>';
    box.appendChild(row);

    var block = document.createElement('div');
    block.className = 'mdd-block';
    var lab = document.createElement('label');
    lab.className = 'mdd-label';
    lab.setAttribute('for', 'meliora-dd');
    lab.textContent = 'お届け希望日';
    var sel = document.createElement('select');
    sel.className = 'mdd-select';
    sel.id = 'meliora-dd';
    buildDateOptions(sel);
    // submit the chosen date as a line item property (only when a date is picked)
    var hidden = document.createElement('input');
    hidden.type = 'hidden';
    hidden.name = 'properties[お届け希望日]';
    hidden.disabled = true;
    sel.addEventListener('change', function () {
      hidden.value = sel.value;
      hidden.disabled = (sel.value === '');
    });
    block.appendChild(lab);
    block.appendChild(sel);
    block.appendChild(hidden);
    box.appendChild(block);

    var cau = document.createElement('p');
    cau.className = 'mdn-caution';
    cau.textContent = '※最短でご注文日の1週間後より、ご希望のお届け日をご指定いただけます。大型家具については時間帯指定不可・配送可能日が限られる場合があり、お届けまでに通常よりお時間をいただきます事ご了承ください。';
    box.appendChild(cau);

    var sub = document.createElement('p');
    sub.className = 'mdn-subnote';
    sub.appendChild(document.createTextNode('※長期休業（GW・お盆・年末年始）シーズンは除く'));
    sub.appendChild(document.createElement('br'));
    sub.appendChild(document.createTextNode('※在庫状況等により変動します'));
    box.appendChild(sub);

    var anchor = form.querySelector('.purchase-section');
    if (anchor && anchor.parentNode) {
      anchor.parentNode.insertBefore(box, anchor);
    } else {
      form.appendChild(box);
    }
  }

  function init() {
    if (!document.getElementById('product')) return;
    detectCouponExcluded();
    watch(document.getElementById('price-preview-pc'));
    watch(document.getElementById('price-preview-sp'));
    injectDelivery();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();